import * as Tooltip from '@radix-ui/react-tooltip'
import { Info } from 'lucide-react'
import type { ReactNode } from 'react'

// InfoTooltip renders a small (i) icon that shows an explanation on hover or focus.
// Used on KPI tiles and chart titles to surface "what is this / how is it calculated"
// without cluttering the main surface. Content is a ReactNode so callers can mix
// headings, paragraphs and short lists.
export default function InfoTooltip({ children, className }: { children: ReactNode; className?: string }) {
  return (
    <Tooltip.Provider delayDuration={150} skipDelayDuration={100}>
      <Tooltip.Root>
        <Tooltip.Trigger asChild>
          <button
            type="button"
            aria-label="More information"
            className={`inline-flex items-center justify-center rounded-full text-slate-300 hover:text-slate-500 focus:outline-none focus-visible:ring-2 focus-visible:ring-danone-cyan focus-visible:ring-offset-1 transition-colors ${className ?? ''}`}
          >
            <Info className="w-3.5 h-3.5" />
          </button>
        </Tooltip.Trigger>
        <Tooltip.Portal>
          <Tooltip.Content
            side="top"
            align="center"
            sideOffset={6}
            className="z-[70] max-w-xs rounded-lg bg-slate-900 px-3 py-2 text-xs text-white shadow-xl data-[state=delayed-open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=delayed-open]:fade-in-0"
          >
            <div className="leading-relaxed [&_p]:mt-1 [&_p:first-child]:mt-0 [&_strong]:font-semibold [&_strong]:text-white">
              {children}
            </div>
            <Tooltip.Arrow className="fill-slate-900" />
          </Tooltip.Content>
        </Tooltip.Portal>
      </Tooltip.Root>
    </Tooltip.Provider>
  )
}
